import ReactDOM from 'react-dom/client'
import { getBrandConfig } from '@/config/config'
import { loadCatalog } from '@/i18n'
import { App } from '@/app'
import { setUTMs } from '@vgw/mar-utm-tracker'
import '@/features/ui-animations/config'
import { I18nProvider } from '@lingui/react'
// eslint-disable-next-line no-restricted-imports
import { i18n } from '@lingui/core'
import { OidcProvider } from '@/features/oidc/oidc'
import { Tracking } from '@/tracking'
import { ToastProvider } from '@vgw/multibrand-fe-toast'
import { StrictMode } from 'react'

const config = getBrandConfig()

await loadCatalog('en')
// set UTMs when application opened (a server navigation happened)
// this call is helpful when user navigating to the protected route
// and root layout has no chance to be called
setUTMs()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <OidcProvider>
        <Tracking apiKey={config.amplitude.apiKey}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </Tracking>
      </OidcProvider>
    </I18nProvider>
  </StrictMode>,
)
